import {
	GroupInvitationCampaign,
	CreateInvitationCampaignRequest,
	UpdateInvitationCampaignRequest,
	InvitationCampaignInvite,
	UpsertInvitationCampaignInvite,
	InvitationInviteType,
	PublicUserActionOnCampaignInvitation,
} from '@front-app/services/GroupInvitationCampaignApi/model';
import { API_V2 } from '../api';

export function fetchGroupInvitationCampaigns(groupId: string): Promise<GroupInvitationCampaign[]> {
	return API_V2.get(`/groups/${groupId}/invitations`)
		.then(({ data }) => data as GroupInvitationCampaign[]);
}

export function createGroupInvitationCampaign(
	groupId: string,
	campaign: CreateInvitationCampaignRequest,
): Promise<GroupInvitationCampaign> {
	return API_V2.post(`/groups/${groupId}/invitations`, campaign)
		.then(({ data }) => data as GroupInvitationCampaign);
}

export function updateGroupInvitationCampaign(
	groupId: string,
	campaignId: string,
	campaign: UpdateInvitationCampaignRequest,
): Promise<GroupInvitationCampaign> {
	return API_V2.put(`/groups/${groupId}/invitations/${campaignId}`, campaign)
		.then(({ data }) => data as GroupInvitationCampaign);
}

export function updateCampaignInvite(
	groupId: string,
	campaignId: string,
	type: InvitationInviteType,
	updatedInvite: UpsertInvitationCampaignInvite,
): Promise<InvitationCampaignInvite> {
	return API_V2.put(`/groups/${groupId}/invitations/${campaignId}/invite/${type}`, updatedInvite)
		.then(({ data }) => data as InvitationCampaignInvite);
}

export function actOnGroupCampaignInvitation(payload: PublicUserActionOnCampaignInvitation): Promise<void> {
	return API_V2.put('/public/invitations', payload)
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		.then(() => {});
}
